module.exports = __webpack_public_path__ + "img/hr-rock-big-14.ed887144.png";